import {
    GET_JOB_PACKS,
    GET_JOB_PACKS2,
    GET_DEPARTMENTS,
    GET_AREAS,
    REMOVE_JOBPACK,
    SET_DATE_FROM,
    SET_DATE_TO,
    SET_FILTER_STATUS,
    SET_SEARCH_JOB_ID,
    SET_PAGE,
    SET_ROW,
    SET_VIEW_TYPE,
    POST_JOB_PACK_STATUS,
    SET_ROW_COUNT,
    SET_PAGE_INDEX,
    SET_SORT_TABLE_TYPE,
    SET_SORT_TABLE_KEY,
    SET_CLICKED_STATUS_JOB_ID,
    SET_MODAL_OPEN,
    SET_SNACKBAR_OPEN,
    SET_SORT_TABLE_AS,
    SET_JOB_YEAR,
    SET_JOB_MONTH,
    MOVE_JOBPACK,
    GET_REGISTERED_USERS,
    SET_TABLE,
    SET_STATUS,
    GET_JOB_PACKSMODAL,
    SET_DAY,
    ARCHIEVE_JOBPACK,
    GET_TEMPLATES,
    SET_FILTER_TEMPLATE,
    TOGGLE_AREAS_DEPT,
    SET_SEARCH_JOB_URN
} from "./types";
import firebase from "firebase/app";
import { push } from "connected-react-router";
import _ from "lodash";
import moment from "moment";

export const setRowCount = (val) => {
    return (dispatch) => {
        dispatch({ type: SET_ROW_COUNT, payload: val });
    };
};
export const setJobYear = (val) => {
    return (dispatch) => {
        dispatch({ type: SET_JOB_YEAR, payload: val });
    };
};
export const setJobMonth = (val) => {
    return (dispatch) => {
        dispatch({ type: SET_JOB_MONTH, payload: val });
    };
};
export const setSnackbarOpen = (value, status) => {
    return (dispatch) => {
        dispatch({ type: SET_SNACKBAR_OPEN, payload: { value, status } });
    };
};
export const setTemplate = (template = false) => {
    return (dispatch) => {
        dispatch({ type: SET_FILTER_TEMPLATE, payload: template });
    };
};
export const setModalOpen = (val) => {
    return (dispatch) => {
        dispatch({ type: SET_MODAL_OPEN, payload: val });
    };
};

export const setClickedStatusJobID = (val) => {
    return (dispatch) => {
        dispatch({ type: SET_CLICKED_STATUS_JOB_ID, payload: val });
    };
};

export const setPageIndex = (val) => {
    return (dispatch) => {
        dispatch({ type: SET_PAGE_INDEX, payload: val });
    };
};

export const setSortTableType = (val) => {
    return (dispatch) => {
        dispatch({ type: SET_SORT_TABLE_TYPE, payload: val });
    };
};

export const setSortTableAs = (val) => {
    return (dispatch) => {
        dispatch({ type: SET_SORT_TABLE_AS, payload: val });
    };
};

export const setSortTableKey = (val) => {
    return (dispatch) => {
        dispatch({ type: SET_SORT_TABLE_KEY, payload: val });
    };
};

export const setStatus = (val) => {
    return (dispatch) => {
        dispatch({ type: SET_STATUS, payload: val });
    };
};
export const setAreasDept = (val) => {
    return (dispatch) => {
        dispatch({ type: TOGGLE_AREAS_DEPT, payload: val });
    };
};
export const setJobUrn = (val) => {
    return (dispatch) => {
        dispatch({ type: SET_SEARCH_JOB_URN, payload: val });
    };
};
export const getRegisteredUsers = () => {
    return (dispatch) => {
        dispatch({ type: GET_REGISTERED_USERS.REQUEST });
        try {
            firebase.auth().onAuthStateChanged((user) => {
                if (user === null) {
                    dispatch({ type: GET_REGISTERED_USERS.FAIL });
                } else {
                    firebase
                        .database()
                        .ref(`/users`)
                        .on("value", (snapshot) => {
                            dispatch({
                                type: GET_REGISTERED_USERS.SUCCESS,
                                payload: snapshot.val(),
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({ type: GET_REGISTERED_USERS.FAIL });
        }
    };
};
export const getJobPackTemplates = () => {
    return (dispatch) => {
        dispatch({ type: GET_TEMPLATES.REQUEST});
        try{
                firebase.auth().onAuthStateChanged((user) => {
                    if(user===null){
                    dispatch({ type: GET_TEMPLATES.FAIL  })
                    } else {
                        firebase    
                            .database()
                            .ref(`/subjects/job_pack_templates/`)
                            .on("value", (snapshot) => {
                                dispatch({
                                    type: GET_TEMPLATES.SUCCESS,
                                    payload: snapshot.val(),
                                });
                            })
                    }
                })
        } catch (e) {
            dispatch({ type: GET_TEMPLATES.FAIL})
        }
    }
}
export const getJobPacks = (stat = false, year = false, month = false) => {
    return (dispatch) => {
        dispatch({ type: GET_JOB_PACKS.REQUEST });

        try {
            if (stat && year && month) {
                firebase.auth().onAuthStateChanged((user) => {
                    if (user) {
                        firebase
                            .database()
                            .ref(`/subjects/jobpacks/${stat}/${year}/${month}/`)
                            .on("value", (snapshot) => {
                                dispatch({
                                    type: GET_JOB_PACKS.SUCCESS,
                                    payload: snapshot.val(),
                                });
                            });
                    } else {
                        dispatch({ type: GET_JOB_PACKS.FAIL });
                    }
                });
            } else {
                dispatch({ type: GET_JOB_PACKS.FAIL });
            }
        } catch {
            dispatch({ type: GET_JOB_PACKS.FAIL });
        }
    };
};

export const getJobPacksModals = (
    stat = false,
    year = false,
    month = false
) => {
    return (dispatch) => {
        dispatch({ type: GET_JOB_PACKSMODAL.REQUEST });

        try {
            if (stat && year && month) {
                firebase.auth().onAuthStateChanged((user) => {
                    if (user) {
                        firebase
                            .database()
                            .ref(`/subjects/jobpacks/${stat}/${year}/${month}/`)
                            .on("value", (snapshot) => {
                                dispatch({
                                    type: GET_JOB_PACKSMODAL.SUCCESS,
                                    payload: snapshot.val(),
                                });
                            });
                    } else {
                        dispatch({ type: GET_JOB_PACKSMODAL.FAIL });
                    }
                });
            } else {
                dispatch({ type: GET_JOB_PACKSMODAL.FAIL });
            }
        } catch {
            dispatch({ type: GET_JOB_PACKSMODAL.FAIL });
        }
    };
};

export const getJobPacks2 = (stat = false, year = false) => {
    return (dispatch) => {
        dispatch({ type: GET_JOB_PACKS2.REQUEST });

        try {
            if (stat && year) {
                firebase.auth().onAuthStateChanged((user) => {
                    if (user) {
                        firebase
                            .database()
                            .ref(`/subjects/jobpacks/${stat}/${year}/`)
                            .on("value", (snapshot) => {
                                dispatch({
                                    type: GET_JOB_PACKS2.SUCCESS,
                                    payload: snapshot.val(),
                                });
                            });
                    } else {
                        dispatch({ type: GET_JOB_PACKS2.FAIL });
                    }
                });
            } else {
                dispatch({ type: GET_JOB_PACKS2.FAIL });
            }
        } catch {
            dispatch({ type: GET_JOB_PACKS2.FAIL });
        }
    };
};

export const getJobPacks2Default = (stat = false, year = false) => {
    return (dispatch) => {
        dispatch({ type: GET_JOB_PACKS2.REQUEST });

        try {
            if (stat && year) {
                firebase.auth().onAuthStateChanged((user) => {
                    if (user) {
                        firebase
                            .database()
                            .ref(`/subjects/jobpacks/${stat}/${year}/`)
                            .on("value", (snapshot) => {
                                dispatch({
                                    type: GET_JOB_PACKS2.SUCCESS,
                                    payload: snapshot.val(),
                                });
                            });
                    } else {
                        dispatch({ type: GET_JOB_PACKS2.FAIL });
                    }
                });
            } else {
                dispatch({ type: GET_JOB_PACKS2.FAIL });
            }
        } catch {
            dispatch({ type: GET_JOB_PACKS2.FAIL });
        }
    };
};

export const getJobPacksDefault = (
    stat = false,
    year = false,
    month = false
) => {
    return (dispatch) => {
        dispatch({ type: GET_JOB_PACKS.REQUEST });

        try {
            if (stat && year && month) {
                firebase.auth().onAuthStateChanged((user) => {
                    if (user) {
                        firebase
                            .database()
                            .ref(`/subjects/jobpacks/${stat}/${year}/${month}/`)
                            .on("value", (snapshot) => {
                                dispatch({
                                    type: GET_JOB_PACKS.SUCCESS,
                                    payload: snapshot.val(),
                                });
                            });
                    } else {
                        dispatch({ type: GET_JOB_PACKS.FAIL });
                    }
                });
            } else {
                dispatch({ type: GET_JOB_PACKS.FAIL });
            }
        } catch {
            dispatch({ type: GET_JOB_PACKS.FAIL });
        }
    };
};

export const getDepartments = () => {
    return (dispatch) => {
        dispatch({ type: GET_DEPARTMENTS.REQUEST });

        try {
            firebase.auth().onAuthStateChanged((user) => {
                if (user === null) {
                    dispatch({ type: GET_DEPARTMENTS.FAIL });
                } else {
                    firebase
                        .database()
                        .ref("/collections/departments")
                        .on("value", (snapshot) => {
                            dispatch({
                                type: GET_DEPARTMENTS.SUCCESS,
                                payload: snapshot.val(),
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({ type: GET_DEPARTMENTS.FAIL });
        }
    };
};
export const getAreas = () => {
    return (dispatch) => {
        dispatch({ type: GET_AREAS.REQUEST });

        try {
            firebase.auth().onAuthStateChanged((user) => {
                if (user === null) {
                    dispatch({ type: GET_AREAS.FAIL });
                } else {
                    firebase
                        .database()
                        .ref("/collections/areas")
                        .on("value", (snapshot) => {
                            dispatch({
                                type: GET_AREAS.SUCCESS,
                                payload: snapshot.val(),
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({ type: GET_AREAS.FAIL });
        }
    };
};
export const setDateFrom = (date = false) => {
    return (dispatch) => {
        dispatch({ type: SET_DATE_FROM, payload: date });
    };
};
export const setDateTo = (date = false) => {
    return (dispatch) => {
        dispatch({ type: SET_DATE_TO, payload: date });
    };
};
export const setSearchVal = (val = "") => {
    return (dispatch) => {
        dispatch({ type: SET_SEARCH_JOB_ID, payload: val });
    };
};
export const setDayFrom = (day = "") => {
    return (dispatch) => {
        dispatch({ type: SET_DAY, payload: day });
    };
};
export const setFilterVal = (filter = "active") => {
    return (dispatch) => {
        dispatch({ type: SET_FILTER_STATUS, payload: filter });
    };
};

export const setPage = (page = 0) => {
    return (dispatch) => {
        dispatch({ type: SET_PAGE, payload: page });
    };
};
export const setRows = (rows = 50) => {
    return (dispatch) => {
        dispatch({ type: SET_ROW, payload: rows });
    };
};

export const setViewType = (type) => {
    return (dispatch) => {
        dispatch({ type: SET_VIEW_TYPE, payload: type });
    };
};
export const setCurrentTable = (table = "active") => {
    return (dispatch) => {
        dispatch({ type: SET_TABLE, payload: table });
    };
};
export const redirectTo = (link) => {
    return (dispatch) => {
        dispatch(push(link));
    };
};

export const postUpdatedStatus = (
    uid = false,
    status = false,
    st = false,
    callback
) => {
    return (dispatch) => {
        dispatch({ type: POST_JOB_PACK_STATUS.REQUEST });

        if (uid) {
            try {
                firebase.auth().onAuthStateChanged((user) => {
                    if (user) {
                        firebase
                            .database()
                            .ref(`/subjects/job_packs/${uid}/profile/`)
                            .update({ status })
                            .then(() => {
                                dispatch({
                                    type: POST_JOB_PACK_STATUS.SUCCESS,
                                });
                                callback(true);
                            });
                    } else {
                        callback(false);
                        dispatch({ type: POST_JOB_PACK_STATUS.FAIL });
                    }
                });
            } catch {
                callback(false);
                dispatch({ type: POST_JOB_PACK_STATUS.FAIL });
            }
        } else {
            callback(false);
            dispatch({ type: POST_JOB_PACK_STATUS.FAIL });
        }
    };
};
export const removeJobPack = (
    uid = false,
    status = false,
    year = false,
    month = false,
    timestamp = false
) => {
    let modalMonth = "";
    let monthref = timestamp.split("-");
    let conditionCheck = monthref[1];
    if (conditionCheck === "01") {
        modalMonth = "jan";
    } else if (conditionCheck === "02") {
        modalMonth = "feb";
    } else if (conditionCheck === "03") {
        modalMonth = "mar";
    } else if (conditionCheck === "04") {
        modalMonth = "apr";
    } else if (conditionCheck === "05") {
        modalMonth = "may";
    } else if (conditionCheck === "06") {
        modalMonth = "jun";
    } else if (conditionCheck === "07") {
        modalMonth = "jul";
    } else if (conditionCheck === "08") {
        modalMonth = "aug";
    } else if (conditionCheck === "09") {
        modalMonth = "sep";
    } else if (conditionCheck === "10") {
        modalMonth = "oct";
    } else if (conditionCheck === "11") {
        modalMonth = "nov";
    } else {
        modalMonth = "dec";
    }

    let conditionCheckYear = monthref[2];
    let modalYear = conditionCheckYear.substring(0, 4);
    return async (dispatch) => {
        try {
            dispatch({ type: REMOVE_JOBPACK.REQUEST });
            console.log(status, uid, timestamp);
            firebase.auth().onAuthStateChanged((user) => {
                if (user && status && uid && timestamp) {
                    firebase
                        .database()
                        .ref(
                            `/subjects/jobpacks/${status}/${modalYear}/${modalMonth}/${uid}/profile`
                        )
                        .update({ deleted: true });

                    dispatch({ type: REMOVE_JOBPACK.SUCCESS });
                } else {
                    dispatch({ type: REMOVE_JOBPACK.FAIL });
                }
            });
        } catch {
            dispatch({ type: REMOVE_JOBPACK.FAIL });
        }
    };
};
export const moveJobPack = (
    uid = false,
    status = false,
    jobData = false,
    reportData = false,
    users = false,
    year = false,
    month = false,
    callback
) => {
    return async (dispatch) => {
        try {
            dispatch({ type: MOVE_JOBPACK.REQUEST });
            let users = await firebase.database().ref(`/users/`).once("value");
            users = users.val();
            let st = {
                active: "active",
                pending: "pending",
                archived: "archived",
            };
            let oldStatus = jobData.status;
            firebase.auth().onAuthStateChanged((user) => {
                if (user) {
                    let receiptCol = [],
                        isReceiptError = false;
                    Object.keys(reportData).map((report_type) => {
                        Object.keys(reportData[report_type]).map(
                            (timestamp) => {
                                let receipt = filterByUserReceipts(
                                    report_type,
                                    timestamp,
                                    uid,
                                    users
                                );
                                if (receipt) {
                                    receiptCol.push(receipt);
                                } else {
                                    isReceiptError = true;
                                }
                                return null;
                            }
                        );
                        return null;
                    });

                    if (isReceiptError) {
                        dispatch({ type: MOVE_JOBPACK.FAIL });
                        callback(false);
                    } else {
                        receiptCol.map((e) => {
                            firebase
                                .database()
                                .ref(
                                    `/users/${e.uid}/receipts/${e.year}/${e.month}/${e.receipt.report_type}/${e.receipt.timestamp}`
                                )
                                .update(
                                    {
                                        subject_name: `jobpacks/${st[status]}/${e.year}/${e.month}`,
                                    },
                                    (error) => {
                                        if (error) {
                                            console.error(error);
                                            callback(false);
                                        }
                                    }
                                );
                            return null;
                        });
                        firebase
                            .database()
                            .ref(
                                `/subjects/jobpacks/${st[status]}/${year}/${month}/${uid}`
                            )
                            .update(
                                {
                                    profile: { ...jobData, status },
                                    reports: reportData,
                                },
                                (error) => {
                                    if (error) {
                                        console.error(error);
                                        callback(false);
                                    }
                                }
                            )
                            .then(() => {
                                firebase
                                    .database()
                                    .ref(
                                        `/subjects/jobpacks/${st[oldStatus]}/${year}/${month}/${uid}`
                                    )
                                    .remove();
                                callback(true);
                            });
                    }
                }
            });
        } catch {
            dispatch({ type: MOVE_JOBPACK.FAIL });
        }
    };
};

export const filterByUserReceipts = (report_type, timestamp, jp_uid, users) => {
    let year = moment(timestamp, "DD-MM-YYYY HH:mm:ss").year();
    let month = moment(timestamp, "DD-MM-YYYY HH:mm:ss")
        .format("MMM")
        .toLowerCase();
    let reports = _.compact(
        Object.keys(users).map((uid) => {
            if (users[uid].receipts)
                return {
                    uid,
                    receipts: users[uid].receipts,
                };
            return null;
        })
    );
    let receipts = [];
    reports.map((e) => {
        let reps = e.receipts;
        let yList = reps[year] ? reps[year] : false;
        let mList = yList[month] ? yList[month] : false;
        let rList = mList[report_type] ? mList[report_type] : false;
        let receipt = rList[timestamp] ? rList[timestamp] : false;
        if (receipt) receipts.push({ uid: e.uid, receipt, month, year });
        return null;
    });

    let newReceipt = [];
    if (receipts.length > 1) {
        receipts.map((e) => {
            if (e.receipt.subject_child === jp_uid) newReceipt.push(e);
            return null;
        });
        if (newReceipt.length > 1) {
            return false;
        }
    } else if (receipts.length === 0) {
        return false;
    } else {
        return receipts[0];
    }
};

export const archieveJobs = (jobids) => {
    if (jobids !== []) {
        return async (dispatch) => {
            try {
                let users = await firebase.database().ref(`/users/`).once("value");
                users = users.val();
                firebase.auth().onAuthStateChanged((user) => {
                    if (user) {
                        jobids &&
                            jobids.map((e) => {
                                let jobData = {};
                                let reportData = {}
                                let epochDate = moment.utc(parseInt(e)).local();
                                let dateFormat = epochDate._d;
                                let month = moment(dateFormat)
                                    .format("MMM")
                                    .toLowerCase();
                                let year = moment(dateFormat)
                                    .format("YYYY")
                                    .toLowerCase();
                                firebase
                                    .database()
                                    .ref(
                                        `/subjects/jobpacks/active/${year}/${month}/${e}`
                                    )
                                    .on("value", (snapshot) => {
                                        jobData = snapshot.val();
                                    });
                                Object.entries(jobData).map((e) => {
                                    if (typeof e[1] !== undefined || e[1] !== null) {
                                        Object.entries(e[1]).map((f) => {
                                            reportData = e[1]
                                            return null;
                                        });
                                    }
                                    return null;
                                });
                                let receiptCol = [],
                                isReceiptError = false;
                                Object.keys(reportData).map((report_type) => {
                                    Object.keys(reportData[report_type]).map(
                                        (timestamp) => {
                                            let receipt = filterByUserReceipts(
                                                report_type,
                                                timestamp,
                                                e,
                                                users
                                            );
                                            if (receipt) {
                                                receiptCol.push(receipt);
                                            } else {
                                                isReceiptError = true;
                                            }
                                            return null;
                                        }
                                    );
                                    return null;
                                });
                                if (isReceiptError) {
                                    dispatch({ type: ARCHIEVE_JOBPACK.FAIL });
                                }
                                else{

                                firebase
                                    .database()
                                    .ref(
                                        `/subjects/jobpacks/archived/${year}/${month}/`
                                    )
                                    .child(e)
                                    .update(jobData)
                                    .then(() => {
                                        firebase
                                            .database()
                                            .ref(
                                                `/subjects/jobpacks/active/${year}/${month}/${e}/`
                                            )
                                            .remove();
                                    })
                                    .then(() => {
                                        firebase
                                            .database()
                                            .ref(
                                                `/subjects/jobpacks/archived/${year}/${month}/${e}/profile`
                                            )
                                            .update({ status: "archived" });
                                    });
                                return null;

                                }
                                return null;
                            });
                    } else {
                        dispatch({ type: ARCHIEVE_JOBPACK.FAIL });
                    }
                });
            } catch {
                dispatch({ type: ARCHIEVE_JOBPACK.FAIL });
            }
        };
    }
};
